import { Box } from '@mui/material';
import * as React from 'react';

export default function AlignCenterBox(props) {
    const { children, ...otherProps } = props
    const sx = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'
    }
    return (
        <Box {...{ sx, ...otherProps }}>
            {children}
        </Box>
    )
}